'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _arrayAsObj = require('shared/utils/arrayAsObj');

var _arrayAsObj2 = _interopRequireDefault(_arrayAsObj);

var _actions = require('./actions');

var _getAllMatchingJobs = require('shared/utils/getAllMatchingJobs');

var _getAllMatchingJobs2 = _interopRequireDefault(_getAllMatchingJobs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
  var page = _ref.ui.highlightedJobs.page,
      highlightedJobs = _ref.pages.home.highlightedJobs,
      data = _ref.data,
      user = _ref.user;

  var selectedJobs = (0, _arrayAsObj2.default)(highlightedJobs.map(function (j) {
    return (0, _extends3.default)({}, data.jobs[j.slug], j);
  }), 'slug');

  var jobs = (0, _getAllMatchingJobs2.default)({
    user: user,
    data: data
  }, selectedJobs);

  return {
    highlightedJobs: jobs,
    page: page
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    slideCarousel: function slideCarousel(dir) {
      return dispatch((0, _actions.slideCarousel)(dir));
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/HighlightedJobs/selectors.js
// module id = 1077
// module chunks = 0